import { Component, OnDestroy, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { AdminState } from '../../../store/admin-store/admin-state.model';
import { NgIf, NgClass } from '@angular/common';
import { UpdateAccountComponent } from '../update-account/update-account.component';
import { SubscriptionHistoryComponent } from '../../subscription/subscription-history/subscription-history.component';
import { CustomerHistoryComponent } from '../customer-history/customer-history.component';
import { CmsTicketComponent } from '../../cms-ticket/cms-ticket.component';
import { PhoneCapabilityComponent } from '../../subscription/phone-capability/phone-capability.component';
import { VehicleHistoryComponent } from '../../subscription/vehicle-history/vehicle-history.component';
import { AppFeaturesComponent } from '../../customer/app-features/app-features.component';
import { ProvisioningHistoryComponent } from '../../provisioning/provisioning-history/provisioning-history.component';
import { UserProfileComponent } from '../../customer/user-profile/user-profile.component';
import { GiveGoodwillComponent } from '../../subscription/give-goodwill/give-goodwill.component';
import { AuthorizeRemoteComponent } from '../../subscription/authorize-remote/authorize-remote.component';
import { UpdateRemoteUserComponent } from '../../subscription/update-remote-user/update-remote-user.component';
import { RemotelistSidemenuComponent } from '../../customer/remotelist-sidemenu/remotelist-sidemenu.component';
import { ShowFlagsComponent } from '../../provisioning/show-flags/show-flags.component';
import { DataConsentComponent } from '../../subscription/data-consent/data-consent.component';
import { EmergencyContactComponent } from '../../subscription/emergency-contact/emergency-contact.component';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    imports: [NgIf, UpdateAccountComponent, NgClass, SubscriptionHistoryComponent, CustomerHistoryComponent, CmsTicketComponent, PhoneCapabilityComponent, VehicleHistoryComponent, AppFeaturesComponent, ProvisioningHistoryComponent, UserProfileComponent, GiveGoodwillComponent, AuthorizeRemoteComponent, UpdateRemoteUserComponent, RemotelistSidemenuComponent, ShowFlagsComponent, DataConsentComponent, EmergencyContactComponent]
})
export class SideNavComponent implements OnInit, OnDestroy {
  /**
  *@arg Property to observe the redux customer store
  **/
  @select('admin') readonly adminObservable: Observable<AdminState>;
  /**
  *@arg Property to determine type of sidenav
  **/
  public type: string;
  /**
  *@arg Property to determine value of sidenav
  **/
  public value: string;

 /**
  *@arg Property to determine optional params of sidenav
  **/
  public otherParams: object;

   /**
  *@arg Property to determine attribute of sidenav to be updated
  **/
  public attribute: string;
  /**
   * @property to store the subscriptions
   */
  private apiSubscription: Subscription;

  constructor() {
  }

  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.apiSubscription = this.adminObservable.subscribe((adminStore) => {
      this.otherParams = adminStore.otherParams;
      this.type = null;
      setTimeout(() => {
        this.type = adminStore.UpdateType;
      });
    });
  }
  /**
   * ondestroy method
   */
  ngOnDestroy() {
    this.apiSubscription?.unsubscribe();
  }
}
